import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  RECENT_SEARCHES_MAX,
  RecentSearchEntry,
  buildRecentSearchEntry,
  entriesFromSearchTabs,
  upsertRecentSearch,
} from '@/utils/recentSearches';

export const RECENT_SEARCHES_STORAGE_KEY = 'disgenet_recent_searches';

export interface RecentSearchesState {
  items: RecentSearchEntry[];
  remember: (search: string, title?: string) => void;
  seedFromSearchTabs: (tabs: Array<{ title: string; search: string; updatedAt: number }>) => void;
  clear: () => void;
}

export const useRecentSearchesStore = create<RecentSearchesState>()(
  persist(
    (set, get) => ({
      items: [],

      remember: (search, title) => {
        const entry = buildRecentSearchEntry(search, title);
        if (!entry) return;
        set({ items: upsertRecentSearch(get().items, entry, RECENT_SEARCHES_MAX) });
      },

      seedFromSearchTabs: tabs => {
        if (get().items.length > 0) return;
        const seeded = entriesFromSearchTabs(tabs, RECENT_SEARCHES_MAX);
        if (seeded.length === 0) return;
        set({ items: seeded });
      },

      clear: () => set({ items: [] }),
    }),
    {
      name: RECENT_SEARCHES_STORAGE_KEY,
      partialize: state => ({ items: state.items.slice(0, RECENT_SEARCHES_MAX) }),
    },
  ),
);
